import styled from '@emotion/styled'
import {FormControl, Select, Box, MenuItem} from '@mui/material'

const StyledSelect = styled(Select)(({theme}) => ({
  background: theme.palette.hpWhite,
  height: '32px',
  minWidth: '240px',
  borderRadius: '4px',
  color: theme.palette.hpAccentBlack,
  maxWidth: '350px',
  marginLeft: '15px',
  fontSize: theme.typography.subtitle1.fontSize,
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.hpPrimary
  },
  '&.Mui-disabled .MuiOutlinedInput-notchedOutline ': {
    color: theme.palette.hpBaseDark,
    WebkitTextFillColor: theme.palette.hpBaseDark
  },
  '&.Mui-disabled .MuiSelect-select ': {
    color: theme.palette.hpBaseDark,
    WebkitTextFillColor: theme.palette.hpBaseDark
  }
}))

const StyledFormControl = styled(FormControl)(({theme}) => ({
  margin: '20px 0px 20px 7px',
  alignItems: 'center',
  '&:disabled': {
    color: theme.palette.hpAccentBlack,
    fontSize: theme.typography.subtitle1.fontSize
  },
  [theme.breakpoints.down('lg')]: {
    margin: '10px 0px 5px 7px'
  },
  [theme.breakpoints.up('lg')]: {
    margin: '20px 0px 20px 7px'
  }
}))

const StyledBox = styled(Box)(({theme}) => ({
  marginLeft: '15px',
  alignItems: 'center',
  justifyContent: 'start',
  display: 'flex',
  minWidth: '240px',
  maxWidth: '350px',
  color: theme.palette.hpAccentBlack
}))

const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  '&.sticky': {
    position: 'sticky',
    top: 0,
    backgroundColor: theme.palette.background.paper,
    maxWidth: '220px',
    zIndex: 9999,
    '&:hover': {
      backgroundColor: theme.palette.hpBaseLightMedium
    },
    '&:focus': {
      backgroundColor: theme.palette.hpBaseLightMedium
    },
    '&.Mui-selected': {
      backgroundColor: theme.palette.hpPrimaryLightest
    }
  },
  '&:hover': {
    backgroundColor: theme.palette.hpBaseLightMedium
  }
}))

export {StyledSelect, StyledFormControl, StyledBox, StyledMenuItem}
